export default __webpack_public_path__ + "static/media/appStore.4abe4569.svg";